import React, {Component} from 'react';
import {Icon, Spin} from 'antd';
import './LoadingIndicator.css';
import {injectIntl} from 'react-intl';

class LoadingIndicator extends Component {
  render() {
    const { size, intl } = this.props;
    const indicator = <Icon type="loading" style={{ fontSize: size || 24 }} spin />;

    return (
      <div className="loading-indicator">
        <Spin indicator={indicator} tip={intl.formatMessage({id:'loading'})} />
      </div>
    );
  }
}

export default injectIntl(LoadingIndicator);
